import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { styles } from '@frontend/design-system';

export const containerStyle = css`
  margin-bottom: ${theme.spacing(1)};

  label {
    ${styles.truncate};
  }
`;
